import classNames from "classnames";
import { MouseEventHandler, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { clockActions } from "../../store/clock-slice";
import { formatClockTime } from "../../utils/formatClockTime";

import styles from "./timer.module.css";

type ClockProps = {
  appointmentId: string;
  pulledUp?: boolean;
  onClick?: MouseEventHandler;
};
const Clock = ({
  appointmentId,
  pulledUp,
  onClick,
}: ClockProps): JSX.Element => {
  const dispatch = useDispatch();

  const clock = useSelector(
    (state: RootState) => state.clock.clocks[appointmentId]
  );

  const currentTime = clock?.currentTime ?? 0;
  const isRunning = clock?.isRunning ?? false;
  const isPaused = clock?.isPaused ?? false;
  
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isRunning && !isPaused) {
      interval = setInterval(() => {
        dispatch(clockActions.tick(appointmentId));
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [dispatch, appointmentId, isRunning, isPaused]);

  const classes = classNames(styles["content"], {
    [styles["content--pulled-up"]]: pulledUp,
    [styles["content--paused"]]: isPaused,
  });

  return (
    <div className={classes} onClick={onClick}>
      {isPaused ? (
        <div className={styles["pause"]}>
          <div className={styles["pause-icon"]}>
            <span />
            <span />
          </div>
          {formatClockTime(currentTime)}
        </div>
      ) : (
        <>
          <div className={styles["timer"]}>{formatClockTime(currentTime)}</div>

          <div className={styles["red-circle"]} />
        </>
      )}
    </div>
  );
};

export default Clock;
